var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.section},[_c('div',{class:_vm.$style.avatar},[_c('div',{class:_vm.$style.avatarContent})]),_c('div',{class:_vm.$style.content},[_c('div',{class:_vm.$style.title}),_c('div',{class:_vm.$style.description})])])
}
var staticRenderFns = []

export { render, staticRenderFns }